meedy.controller('meedy.popupMessagesViewController', ['$scope', '$state', '$sce', '$mdDialog', 'message', 'messagesModel',
    function ($scope, $state, $sce, $mdDialog, message, messagesModel) {

        function setData() {
            $scope.titleSource = message.title;
            $scope.contentSource = $sce.trustAsHtml(message.content);
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on(Event.MEEDY.MESSAGES.GET_BY_ID.SUCCESS, function(event, message) {
                $scope.titleSource = message.title;
                $scope.contentSource = message.content;
            });
        }

        function setActions() {
            $scope.cancel = function() {
                $mdDialog.cancel();
            };

        }

        function configureInterface() {

        }

        function initialize() {

        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);